module.exports = __webpack_public_path__ + "static/media/答疑一@2x.cd1640fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_171/images/答疑一@2x.png
// module id = 1554
// module chunks = 0